import React from 'react'
import DeleteOutlined from '@ant-design/icons/DeleteOutlined'
import LinkOutlined from '@ant-design/icons/LinkOutlined'

import { LntButton, LntCheckbox, LntFormItem, LntInput } from '@app/components/base'
import { TopFilterItem } from '@app/components'
import { Switch } from '@app/components/util'

import { BUTTON_TYPE, SIZE } from '@app/constants'
import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'

import styles from '../styles.module.scss'

import type { TopInfoProductProps } from './types'

const { Case } = Switch

export const TopInfoProduct: React.FC<TopInfoProductProps> = ({
  dataSource,
  disabled,
  onShowLentaConfirmModalToggle,
  onShowProductLentaDrawer
}) => {
  return (
    <>
      <h6 className={ styles.productCardForm__title }>Информация о товаре</h6>

      <Switch>
        <Case condition={ disabled }>
          <div className={ styles.productCardForm__generalProduct }>
            <div className={ styles.generalProduct__info }>
              <span className={ styles.generalProductInfo__code }>Код товара: { dataSource?.generalProduct?.code }</span>
              <span>{ dataSource?.name }</span>
            </div>
            <LntButton
              type={ BUTTON_TYPE.link }
              size={ SIZE.small }
              onClick={ onShowLentaConfirmModalToggle }
            >
              <DeleteOutlined />
            </LntButton>
          </div>
        </Case>
        <Case condition={ !disabled }>
          <div className={ styles.productCardForm__itemsWrapper }>
            <LntFormItem
              className={ styles.productCardForm__itemFullSize }
              name='name'
              defaultValue={ dataSource?.name ?? '' }
            >
              <LntInput placeholder={ FILTERS_PLACEHOLDERS.name } />
            </LntFormItem>

            <LntButton
              type={ BUTTON_TYPE.link }
              size={ SIZE.middle }
              disabled={ !dataSource?.isConfirmed }
              onClick={ onShowProductLentaDrawer }
            >
              <LinkOutlined />
              Товар Ленты
            </LntButton>
          </div>

          <TopFilterItem
            fullWide
            freeSizes
          >
            <LntFormItem
              name='isCHTM'
              defaultValue={ dataSource?.isCHTM }
            >
              <LntCheckbox value={ dataSource?.isCHTM }>ЧТМ</LntCheckbox>
            </LntFormItem>

            <LntFormItem
              name='isEPP'
              defaultValue={ dataSource?.isEPP }
            >
              <LntCheckbox value={ dataSource?.isEPP }>ЕРР</LntCheckbox>
            </LntFormItem>
          </TopFilterItem>
        </Case>
      </Switch>
    </>
  )
}
